import { t } from "i18next";

import { cn } from "@/lib/utils";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Skeleton } from "@/components/ui/skeleton";

interface ReviewLoaderProps {
  className?: string;
}

export default function ReviewLoader({ className }: ReviewLoaderProps) {
  return (
    <ScrollArea className="h-[calc(100dvh_-_4rem)]">
      <title>{`${t("profile:profilePage")} - Ximly`}</title>
      <div
        className={cn(
          "bg-background flex min-h-dvh flex-col items-center justify-center gap-4 space-y-6 px-1 sm:px-8 xl:flex-row xl:items-start",
          className,
        )}
      >
        <div className="w-full space-y-6 lg:w-[50rem]">
          {/* Header Section Skeleton */}
          <div className="relative h-[400px] w-full rounded-lg border">
            {/* Banner */}
            <Skeleton className="h-[200px] w-full" />

            {/* Avatar */}
            <div className="absolute top-32 left-6">
              <Skeleton className="h-32 w-32 rounded-lg" />
            </div>

            {/* Name and Location */}
            <div className="mt-16 space-y-2 px-8">
              <Skeleton className="h-12 w-48" />
              <Skeleton className="h-8 w-64" />
            </div>
          </div>

          <div className="container mx-auto max-w-4xl">
            <div className="w-full space-y-6">
              {/* About Section Skeleton */}
              <div className="flex h-fit flex-col gap-2 rounded-lg border p-6 shadow-xs">
                <div className={"flex items-center justify-between"}>
                  <Skeleton className="h-8 w-32" />
                  <div className={"flex items-center gap-4"}>
                    <Skeleton className="h-8 w-44" />
                    <Skeleton className="h-8 w-24" />
                  </div>
                </div>
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20].map(
                  (i) => (
                    <div key={i} className={"flex h-24 justify-between rounded-lg border p-2"}>
                      <Skeleton className="size-13 rounded-full" />
                      <div className={"flex w-[90%] flex-col items-end gap-2"}>
                        <div className={"flex w-full justify-between"}>
                          <Skeleton className="h-6 w-32" />
                          <Skeleton className="h-6 w-44" />
                        </div>
                        <Skeleton className="h-full w-full" />
                      </div>
                    </div>
                  ),
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Sidebar */}
        <div className="flex w-full max-w-4xl flex-col gap-4 sm:min-w-[23rem] lg:w-[50rem] xl:w-fit">
          {/* Settings Card Skeleton */}
          <div className="rounded-lg border p-6 shadow-xs xl:w-[23rem]">
            <div className="mb-4 flex flex-col items-center justify-center gap-2">
              <Skeleton className="h-6 w-full" />
              <Skeleton className="h-12 w-full" />
            </div>
          </div>
        </div>
      </div>
    </ScrollArea>
  );
}
